import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { GlossaryProvider } from "@learningblocks/storybook-components";
import { Image } from "@learningblocks/shared-components";
import GlossaryIcon from "./Glossary.Icon.svg";
import style from "./style.module.scss";

export function GlossaryButton(props) {
  const intl = useIntl();
  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onOpenGlossary("");
  };

  const className = `${style.glossaryButton} ${props.className}`;

  return (
    <span
      tabIndex="0"
      className={className}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          onOpenGlossary("");
        }
      }}
      role="button"
      aria-label={intl.formatMessage({
        id: "Open Glossary",
        defaultMessage: "Open Glossary",
        description: "",
      })}
    >
      <Image src={GlossaryIcon} atl="" />
      <h5>
        <FormattedMessage
          id="Glossary"
          defaultMessage="Glossary"
          description=""
        />
      </h5>
    </span>
  );
}
